module.exports = __webpack_public_path__ + "static/media/29bbeda7.jpg";